import { Injectable } from '@angular/core';
import { LoggedInUser } from '@models/logged-in-user.class';
import { Store } from '@ngrx/store';
import { Map } from 'immutable';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

import { AppState } from 'src/app';
import { ApiGatewayService } from 'src/shared';

@Injectable()
export class SecurityService {
  private appConfiguration$: Observable<any>;
  private gbmAPI: string;
  private gbmComAPI: string;

  constructor(
    private store: Store<AppState>,
    private apiGatewayService: ApiGatewayService,
  ) {
    this.appConfiguration$ = this.store.select('config');

    this.appConfiguration$
      .pipe(
        filter((mapShadowed: any) => Map.isMap(mapShadowed)),
        map((mapShadowed: any) => mapShadowed.toJS()),
        take(1),
      )
      .subscribe((value) => {
        this.gbmAPI = value.api;
        this.gbmComAPI = value.gbmComApi;
      });
  }

  getUser(): Observable<LoggedInUser> {
    return this.apiGatewayService.get(`${this.gbmAPI}api/User/GetUser`);
  }

  setSessionDotCom(identityToken: string): Observable<{ expires_in: number }> {
    return this.apiGatewayService.post(`${this.gbmComAPI}v1/session`, {
      identity_token: identityToken,
    });
  }
}
